export const ADD_TO_CART = 'Add To Cart';
export const BREAK_MOBILE = 767;
export const DISABLED = 'disabled';
export const FOCUSABLE_ELEMENTS = 'button, [href], input, select, textarea:not(.ada-hidden)';
export const OFF = 'off';
export const ON = 'on';
export const SOLD_OUT = 'Sold Out';
export const STOREFRONT_ACCESS_TOKEN = '423c07dc74351fddcbc7d53f64facc49';
export const SUBSCRIBE_SERVICE = 'https://homer-h2jz6ksnha-uc.a.run.app/';
export const KLAVIYO_API_KEY = 'pk_a491bffa88b1ef5ea53729c68c6fef631f';
export const KLAVIYO_COMPANY_ID = 'QHaFV6';
export const KLAVIYO_BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
export const KLAVIYO_LIST_ID = 'Y6nRLr'; // Replace with your actual list ID for SMS consent
